import * as DeviceAPI from '@/api/device';
import { normalConfirm, deleteConfirm, disabledConfirm } from '@/libs/ant.design.fn';

export default {
  data() {
    return {
      // 导出
      showExport: false,
      // 导出文件名
      exportFileName: '',
      // 导出文件名后缀
      exportFileNameExt: '.xlsx',
    };
  },

  methods: {
    // 维护设备
    maintenanceDeviceInMixins({ params = {}, devTitle = '', devName = '', callback = null }) {
      if (params) {
        const h = this.$createElement;

        const options = {
          onOk: () => {
            this.$store.commit('setFreeze', this.$t('com_ongoing_delete'));
            DeviceAPI.DeviceMaintain(params)
              .then(res => {
                if (res.code === 0) {
                  this.$message.success(this.$t('com_msg_maintenance_success'));

                  // 重新获取列表
                  callback && callback();
                } else {
                  this.$message.error(this.$t('com_msg_maintenance_fail'));
                }
              })
              .catch(() => {
                this.$message.error(this.$t('com_msg_maintenance_fail'));
              })
              .finally(() => {
                this.$store.commit('setFreeze', false);
              });
          },
        };

        // title
        options.title = devTitle || this.$t('device_confirm_maintain_title');

        // content
        options.content = [];
        if (devName) {
          options.content.push(h('div', devName));
        }
        options.content.push(h('div', this.$t('device_confirm_maintain_content')));

        normalConfirm.call(this, options);
      }
    },

    // 删除设备
    deleteDeviceInMixins({ params = {}, devTitle = '', devName = '', callback = null }) {
      if (params) {
        const h = this.$createElement;

        const options = {
          onOk: () => {
            this.$store.commit('setFreeze', this.$t('com_ongoing_delete'));
            DeviceAPI.DeviceDelete(params)
              .then(res => {
                if (res.code === 0) {
                  this.$message.success(this.$t('com_msg_delete_success'));

                  // 重新获取列表
                  // this.getList();
                  callback && callback();
                } else {
                  this.$message.error(this.$t('com_msg_delete_fail'));
                }
              })
              .catch(() => {
                this.$message.error(this.$t('com_msg_delete_fail'));
              })
              .finally(() => {
                this.$store.commit('setFreeze', false);
              });
          },
        };

        // title
        options.title = devTitle || this.$t('device_confirm_delete_title');

        // content
        if (devName) {
          options.content = h('div', [
            h('div', devName), // devName 部分
            h('div', this.$t('device_confirm_delete_confirm')), // 另一部分内容
          ]);
        }

        deleteConfirm.call(this, options);
      }
    },

    // 禁用设备
    disabledDeviceInMixins({ params = {}, devTitle = '', devName = '', callback = null }) {
      if (params) {
        const h = this.$createElement;

        const options = {
          title: this.$t('device_confirm_disabled_title'),
          content: h('div', devName.name),
          centered: true,
          onOk: () => {
            this.deleteLoading = true;
            this.$store.commit('setFreeze', this.$t('com_ongoing_disable'));

            DeviceAPI.DeviceStatusToggle(params)
              .then(res => {
                if (res.code === 0) {
                  this.$message.success(this.$t('com_msg_disabled_success'));

                  // 重新获取列表
                  callback && callback();
                } else {
                  this.$message.error(this.$t('com_msg_disabled_fail'));
                }
              })
              .catch(() => {
                this.$message.error(this.$t('com_msg_disabled_fail'));
              })
              .finally(() => {
                this.$store.commit('setFreeze', false);
              });
          },
        };

        // title
        options.title = devTitle || this.$t('device_confirm_disabled_title');

        // content
        if (devName) {
          options.content = h('div', [
            h('div', devName), // devName 部分
            h('div', this.$t('device_confirm_disabled_confirm')), // 另一部分内容
          ]);
        }

        disabledConfirm.call(this, options);
      }
    },

    // 启用设备
    enableDeviceInMixins({ params = {}, devTitle = '', devName = '', callback = null }) {
      if (params) {
        const h = this.$createElement;

        const options = {
          title: this.$t('device_confirm_eanbled_title'),
          onOk: () => {
            this.$store.commit('setFreeze', this.$t('com_ongoing_enable'));
            DeviceAPI.DeviceStatusToggle(params)
              .then(res => {
                if (res.code === 0) {
                  this.$message.success(this.$t('com_form_enabled_success'));

                  // 重新获取列表
                  // this.getDeviceList();
                  callback && callback();
                } else {
                  this.$message.error(this.$t('com_form_enabled_fail'));
                }
              })
              .catch(() => {
                this.$message.error(this.$t('com_form_enabled_fail'));
              })
              .finally(() => {
                this.$store.commit('setFreeze', false);
              });
          },
        };

        // title
        options.title = devTitle || this.$t('device_confirm_eanbled_title');

        // content
        if (devName) {
          options.content = h('div', devName);
        }

        disabledConfirm.call(this, options);
      }
    },

    // 导出文件 - 文件名
    handleExportName({ name = 'device_info_' }) {
      return name + new Date().getTime();
    },
  },
};
